/**
 * Assistants that connect with the one JuDI address.
 * Settings shows `steps`. Help uses its own, longer wording.
 */

export type HostedAssistant = {
  name: string;
  steps: readonly string[];
};

export const HOSTED_ASSISTANTS: readonly HostedAssistant[] = [
  {
    name: "Grok",
    steps: [
      "In Grok, open Connectors, add a Custom connector, and paste the address above.",
      "Sign in to JuDI and choose what Grok may do.",
      "Grok shows up under Connected assistants. Ask it what you have today.",
    ],
  },
  {
    name: "Claude",
    steps: [
      "In Claude, open Customize, then Connectors. Add a custom connector and paste the address above. If Claude asks how to sign in, choose Register automatically. Leave a client ID and a secret empty.",
      "Choose Connect. Sign in to JuDI and choose what Claude may do.",
      "Claude shows up under Connected assistants. Ask it what you have today.",
    ],
  },
  {
    name: "ChatGPT",
    steps: [
      "In ChatGPT, open Settings, then Apps. Open Advanced settings and turn on Developer mode.",
      "Choose Create app. Name it JuDI. Paste the address above and choose OAuth. Leave a client ID and a secret empty.",
      "ChatGPT sends you to JuDI. Sign in and choose what ChatGPT may do.",
      "In a chat, open the plus menu, choose Developer mode, and select JuDI. Ask what you have today.",
    ],
  },
  {
    name: "Codex",
    steps: [
      "In Codex, add the address above as a remote server. Leave a client ID empty.",
      "Sign in to JuDI and choose what Codex may do.",
      "Ask Codex what you have today.",
    ],
  },
];

/** "Grok, Claude, ChatGPT, and Codex", or the same list with "or". */
export function hostedAssistantNames(conjunction: "and" | "or"): string {
  const names = HOSTED_ASSISTANTS.map((assistant) => assistant.name);
  if (names.length <= 1) return names[0] ?? "";
  if (names.length === 2) return `${names[0]} ${conjunction} ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, ${conjunction} ${names[names.length - 1]}`;
}
